import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Input, Tag, Skeleton } from "antd";
import "./index.scss";
import _ from "lodash"; // 引入lodash来使用_.debounce
import { tutorial_tag } from "@/assets/jfData";
import axiosInstance from "@/axios/axiosInstance";
import tool from "@/assets/tool";

const { Header, Content, Footer } = Layout;
const Tutor = () => {
  const [videoList, setVideoList] = useState([]);
  const [selectedParent, setSelectedParent] = useState("all");
  const [selectedC, setSelectedClick] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [searchTitle, setSearchTitle] = useState("");
  const pageSize = 20;
  const containerRef = useRef(null);

  const findMatchedItems = (keysStr) => {
    const keys = keysStr.split(",").map((key) => key.trim()); // 将字符串分割成数组并去除空格
    const result = []; // 存放匹配结果
    tutorial_tag.forEach((parent) => {
      const matchedChildren =
        parent.children &&
        parent.children.filter((child) => keys.includes(child.key));
      if (matchedChildren && matchedChildren.length > 0) {
        matchedChildren.forEach((matchedChild) => {
          result.push({ ...matchedChild, parentTitle: parent.title }); // 可以添加 parentTitle 字段来标识父项
        });
      }
    });

    return result;
  };

  const getTutorialData = useCallback(
    async (title = "", pageNum = 1) => {
      if (loading || (!hasMore && pageNum > 1)) return;

      try {
        setLoading(true);
        const labelParam =
          selectedC.length === 0
            ? ""
            : selectedC.map((item) => item.key).join(",");

        const response = await axiosInstance.get(
          `/tutorial/page/list?label=${labelParam}&title=${title}&page=${pageNum}&limit=${pageSize}`
        );

        const newData = response.data.data || [];
        const totalCount = response.data.page.totalCount;

        if (pageNum === 1) {
          setVideoList(newData);
        } else {
          setVideoList((prev) => [...prev, ...newData]);
        }

        setTotal(totalCount);
        const currentTotal =
          pageNum === 1 ? newData.length : videoList.length + newData.length;
        setHasMore(currentTotal < totalCount);
      } catch (error) {
        console.error("Error fetching tutorial data:", error);
      } finally {
        setLoading(false);
      }
    },
    [selectedC, loading, hasMore, videoList.length]
  );

  // 处理搜索
  const handleSearch = (value) => {
    setSearchTitle(value);
    setPage(1);
    setVideoList([]);
    setHasMore(true);
    getTutorialData(value, 1);
  };

  // 防抖处理搜索
  const debouncedSearch = useCallback(
    _.debounce((value) => {
      handleSearch(value);
    }, 500),
    []
  );

  const handleChange = (e) => {
    const value = e.target.value;
    debouncedSearch(value);
  };

  // 处理滚动加载
  const handleScroll = useCallback(() => {
    if (!containerRef.current || loading || !hasMore) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (documentHeight - (scrollTop + windowHeight) < 100) {
      if (videoList.length < total) {
        setPage((prev) => prev + 1);
        getTutorialData(searchTitle, page + 1);
      }
    }
  }, [
    loading,
    hasMore,
    page,
    videoList.length,
    total,
    searchTitle,
    getTutorialData,
  ]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    getTutorialData(searchTitle, 1);
    document.title =
      "渐风AI,AI技术教程,人工智能开发实践,AI技术学习文章,AI技术课";
  }, [selectedC]); // 当标签选择改变时重新加载

  const handleParentClick = (parent) => {
    setSelectedParent(parent);
    if (parent === "all") {
      setSelectedClick([]);
    } else {
      setSelectedClick([]);
    }
  };

  const handleShiyClick = (tag, checked) => {
    const nextSelectedTags = checked
      ? [...selectedC, tag]
      : selectedC.filter((t) => t.key !== tag.key);
    setSelectedClick(nextSelectedTags);
  };

  const renderChildTags = () => {
    if (!selectedParent) return null;
    const parentTag = tutorial_tag.find((tag) => tag.key === selectedParent);
    if (!parentTag || !parentTag.children) return null;
    return (
      <div style={{ marginTop: 10 }}>
        {parentTag.children.map((child) => (
          <Tag.CheckableTag
            color={"blue"}
            className={`${child.key == selectedC ? "checkedP" : "checkedc"}`}
            key={child.key}
            style={{ marginRight: 8, cursor: "pointer" }}
            checked={selectedC.find((v) => v.key == child.key)}
            onChange={(checked) => handleShiyClick(child, checked)}
          >
            {child.title}
          </Tag.CheckableTag>
        ))}
      </div>
    );
  };

  const toDetail = (record) => {
    // 构建 URL 参数
    const params = new URLSearchParams({
      id: record.tutorialId,
      // profilePictureUrl: record.profilePictureUrl,
      // nickName: record.nickName,
    });
    const url = `/tutorial_detail?${params.toString()}`;
    window.open(url, "_blank"); // 在新窗口或新标签页中打开
  };

  const getlaBel = (v) => {
    let lab = findMatchedItems(v.label);
    return lab.map((v) => {
      return (
        <span key={v.key} className="lab">
          {v.title}
        </span>
      );
    });
  };

  const tutorial_tag_with_all = [
    { key: "all", title: "全部", children: [] },
    ...tutorial_tag,
  ];

  return (
    <div ref={containerRef}>
      <Layout className="tutorList">
        <Header className="videolist-hea desktop-only">
          <div className="name">文章教程</div>
          <Input
            placeholder="搜索文章"
            onChange={handleChange}
            allowClear
            className="search-input"
          />
        </Header>

        <Content className="tutorList-vio-cont desktop-only">
          <div className="filter-section">
            <div className="name">学习内容</div>
            <div className="tags-container">
              <div className="parent-tags">
                {tutorial_tag_with_all.map((parent) => (
                  <Tag
                    key={parent.key}
                    onClick={() => handleParentClick(parent.key)}
                    className={`tag-item ${
                      parent.key === selectedParent ? "checkedP" : ""
                    }`}
                  >
                    {parent.title}
                  </Tag>
                ))}
              </div>
              <div className="child-tags">{renderChildTags()}</div>
            </div>
          </div>
        </Content>

        <Footer className="tutro_content">
          <div className="bor_content">
            {videoList.length ? (
              <>
                {videoList.map((v) => (
                  <div
                    key={v.tutorialId}
                    className="video-fot"
                    onClick={() => toDetail(v)}
                  >
                    <div className="article-content">
                      <div className="cont_title">{v.title}</div>
                      <div className="cont_dig">{v.digest}</div>
                      <div className="article-meta">
                        <div className="user-info">
                          <img
                            src={`/file/${v.profilePictureUrl}`}
                            alt=""
                            className="tx"
                          />
                          <span className="nickName">
                            {v.nickName || tool.hideMiddleFour(v.phone)}
                          </span>
                          <span className="createTime">
                            {v.createTime.split(" ")[0]}
                          </span>
                        </div>
                        <div className="tags">{getlaBel(v)}</div>
                      </div>
                    </div>
                    <div className="article-cover">
                      <img src={v.cover} alt="" className="nj" />
                    </div>
                  </div>
                ))}
                {loading && (
                  <div className="loading-more">
                    <Skeleton active paragraph={{ rows: 1 }} />
                  </div>
                )}
                {!hasMore && videoList.length > 0 && (
                  <div className="no-more">已经到底了</div>
                )}
              </>
            ) : loading ? (
              <Skeleton active paragraph={{ rows: 4 }} />
            ) : (
              <div className="empty-state">
                {searchTitle
                  ? `未找到包含"${searchTitle}"的教程`
                  : "暂无相关教程"}
              </div>
            )}
          </div>
          <div className="right">
            <span className="tjauto">推荐作者</span>
          </div>
        </Footer>
      </Layout>
    </div>
  );
};

export default Tutor;
